import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { TokenService } from './services/token.service';

@Injectable({
  providedIn: 'root'
})
export class RedirectGuard implements CanActivate {
  
  constructor(
    private tokenService: TokenService,
    private router: Router
  ){}

  canActivate() {
    const isValidToken = this.tokenService.isValidToken();
    if (isValidToken) {
      this.router.navigate(['/internal/home']);
      return false;
    }
    return true;
  }
  
  
}
